module.exports = __webpack_public_path__ + "static/referencement-a73d12da9573058bbc8b26c2fd44a4d4.jpg";